import { useRouter } from 'next/router'

import { apolloClient } from '@/components/AuthApolloProvider'
import { GetCompaniesDocument, Company } from '@graphql'

export function useCompany() {
  const { query } = useRouter()
  const companyId = query.company as string

  const data = apolloClient.readQuery({
    query: GetCompaniesDocument,
    variables: {
      filter: {
        displayId: {
          eq: companyId
        }
      }
    }
  })

  return data?.companies?.edges[0]?.node as Company
}
